import React from 'react';
import PropTypes from 'prop-types';

const PostText = ({ text }) => (
    <div className={'post-text-row row'}>
        <div className={'post-text col-12'}>{text}</div>
    </div>
);

PostText.propTypes = {
    text: PropTypes.string
};

export default PostText;
